<template>
  <div>
    <confirm-dialog ref="confirm">
      <v-row slot="action" no-gutters>
        <v-spacer></v-spacer>
        <v-btn color="darkColor" small ref="yes" rounded class="normal-letter-spacing px-12 py-4 ml-2"
          style="color: white" @click="confirmDialogConfirmFunction()" :disabled="disabelConfirm">
          بله
        </v-btn>
        <v-btn small rounded text ref="no" class="normal-letter-spacing px-12 confirm-cancel-btn"
          @click="confirmDialogCancelFunction()">
          خیر
        </v-btn>
      </v-row>
    </confirm-dialog>
    <v-dialog v-model="lakeModal" width="700" persistent>
      <v-card>
        <v-row no-gutters>
          <v-col cols="12" class="modal-header py-3">
            <v-row no-gutters>
              <v-spacer></v-spacer>
              <v-icon color="darkColor">mdi-plus</v-icon>
              <span class="modal-title-text mr-2">فاقدی</span>
              <v-spacer></v-spacer>
            </v-row>
          </v-col>
        </v-row>
        <v-card-text class="mt-8">
          <v-row>
            <v-col cols="6">
              <v-row>
                <span>افزودن فاقدی ها</span>
                <v-divider class="mt-3 mr-2 ml-2"></v-divider>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <v-autocomplete :items="allStationsForOther" no-data-text="اطلاعاتی وجود ندارد" dense outlined
                    clearable clear-icon="mdi-close-circle-outline" item-text="title" item-value="id" label="پایگاه*"
                    v-model="stationCoverageZoneSupportStation.stationId" autocomplete="off"
                    prepend-inner-icon="mdi-fireplace-off mdi-18px"></v-autocomplete>
                </v-col>
                <v-col cols="12">
                  <v-autocomplete :items="priorityList" no-data-text="اطلاعاتی وجود ندارد" dense outlined clearable
                    clear-icon="mdi-close-circle-outline" item-text="title" item-value="id" label="اولویت*"
                    v-model="stationCoverageZoneSupportStation.priority" autocomplete="off"
                    prepend-inner-icon="mdi-numeric mdi-18px"></v-autocomplete>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <v-divider></v-divider>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6" class="text-center mt-4">
                  <v-btn color="darkColor" @click="addStationCoverageZoneSupportStationFunction()" dark rounded
                    class="normal-letter-spacing px-12">
                    ثبت
                  </v-btn>
                </v-col>
                <v-col cols="6" class="text-center mt-4">
                  <v-btn rounded color="darkColor" outlined @click="closeStationLakeModal()"
                    class="normal-letter-spacing px-10">
                    بستن
                  </v-btn>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="6">
              <v-row>
                <span>لیست فاقدی ها</span>
                <v-divider class="mt-3 mr-2"></v-divider>
              </v-row>
              <v-row class="lake-station-list">
                <v-col cols="12">
                  <v-card v-for="item in allStationCoverageZoneSupportStations" :key="item.id" elevation="4"
                    class="lake-station-list-card mt-3">
                    <v-card-text>
                      <v-row no-gutters>
                        <v-col cols="11">
                          <v-row>
                            <v-col cols="6" class="py-3">
                              <span>
                                پایگاه:
                                <span>{{ item.station ? item.station.title : '-' }}</span>
                              </span>
                            </v-col>
                            <v-col cols="6" class="py-3">
                              <span>
                                اولویت:
                                <span>{{ item.priority ? item.priority : '-' }}</span>
                              </span>
                            </v-col>
                          </v-row>
                        </v-col>
                        <v-col cols="1" class="mt-n1">
                          <v-icon color="darkColor" @click="showDeleteLakeConfirmFunction(item.id)">
                            mdi-delete
                          </v-icon>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="fenceModal" width="90%">
      <v-card v-if="fenceModal">
        <v-row no-gutters>
          <v-col cols="12" class="modal-header py-3">
            <v-row no-gutters>
              <v-spacer></v-spacer>
              <v-icon color="darkColor">mdi-map</v-icon>
              <span class="modal-title-text mr-2">فنس</span>
              <v-spacer></v-spacer>
            </v-row>
          </v-col>
        </v-row>
        <v-card-text class="mt-2">
          <v-row>
            <v-col cols="12">
              <div id="fanceMap">
                <l-map v-if="isFenceMapReadyToShow" ref="fancemap" style="height: 66vh !important" :zoom="fanceZoom"
                  :center="center_My" :options="fanceMapOptions" @update:center="fanceCenterUpdate"
                  @update:zoom="fanceZoomUpdate" @ready="fanceMapInvalidate()">
                  <l-tile-layer :url="mapTileUrl" :attribution="attribution"></l-tile-layer>
                  <l-polygon @ready="readyCurrentLayer" :lat-lngs="currentFenceCoords" v-if="addFlag == false"
                    :color="currentFenceColor" :fillColor="currentFenceColor"></l-polygon>
                  <l-polygon :color="item.color" :fillColor="item.color" v-for="(item, index) in otherFenceCoords"
                    :key="index" :lat-lngs="item.latlngs" :_leaflet_id="index" :options="{ id: index }"></l-polygon>
                  <l-control position="bottomleft" v-if="toggleEditFlag == true">
                    <v-btn icon small tile class="no-letter-space" @click="toggleEditMode()" style="
                        background-color: white;
                        border: solid;
                        border-width: 2px;
                        border-radius: 5px;
                        border-color: #c2bfba;
                        padding: 15px;
                      ">
                      <v-icon>mdi-vector-polyline-edit</v-icon>
                    </v-btn>
                  </l-control>
                </l-map>
              </div>
            </v-col>
            <v-col cols="12">
              <v-row no-gutters>
                <v-col cols="3">
                  <v-text-field outlined label="عنوان" dense type="text" v-model="stationCoverageZone.title" clearable
                    clear-icon="mdi-close-circle-outline" v-on:keyup.enter="addStationCoverageZoneFunction()"
                    class="input-label" prepend-inner-icon="mdi-text mdi-18px"></v-text-field>
                </v-col>
                <v-col cols="3" class="mr-4">
                  <v-text-field outlined label="رنگ" dense v-model="colorValue"
                    v-on:keyup.enter="addStationCoverageZoneFunction()" class="input-label"
                    prepend-inner-icon="mdi-palette mdi-18px" v-mask="mask" hide-details>
                    <template v-slot:append>
                      <v-menu v-model="menu" top nudge-bottom="105" nudge-left="16" :close-on-content-click="false">
                        <template v-slot:activator="{ on }">
                          <div :style="swatchStyle" v-on="on" />
                        </template>
                        <v-card style="z-index: 99999999999999">
                          <v-card-text class="pa-0">
                            <v-color-picker v-model="colorValue" flat @input="changeColor()" mode="hexa"
                              style="z-index: 99999999999999" />
                          </v-card-text>
                        </v-card>
                      </v-menu>
                    </template>
                  </v-text-field>
                </v-col>
                <v-spacer></v-spacer>
                <v-col cols="1" class="ml-9">
                  <v-btn color="darkColor" @click="showConfirmDialogFunction()" dark rounded
                    class="normal-letter-spacing px-12">
                    ثبت
                  </v-btn>
                </v-col>
                <v-col cols="1" class="ml-5">
                  <v-btn rounded color="darkColor" outlined @click="closeStationCoverageZone()"
                    class="normal-letter-spacing px-10">
                    انصراف
                  </v-btn>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-row no-gutters class="table-content">
      <v-col cols="12" class="mr-2">
        <v-img :src="tableImg.val">
          <v-row>
            <v-col cols="3">
              <v-img :src="tableTitleImage.val" contain max-height="14vh" max-width="27vh">
                <v-row>
                  <v-col cols="1"></v-col>
                  <v-col class="header-title" cols="10">
                    <span class="header-title-content">مدیریت فنس منطقه</span>
                  </v-col>
                  <v-spacer></v-spacer>
                </v-row>
              </v-img>
            </v-col>
            <v-col cols="1" class="mr-n16">
              <v-btn fab color="darkColor" elevation="0" small dark @click="backTopage()"
                class="mt-3 normal-letter-spacing mr-n16">
                <v-icon class="ml-1">mdi-arrow-right mdi-18px</v-icon>
              </v-btn>
            </v-col>
            <v-col cols="3" class="mr-n10">
              <v-text-field outlined rounded placeholder="جستجو..." append-icon="mdi-magnify" dense
                v-model="searchTitle" class="mt-3 mr-n16"></v-text-field>
            </v-col>
            <v-spacer></v-spacer>
            <v-col cols="2" class="text-left">
              <v-btn rounded color="darkColor" dark @click="enableAddEditFunction(1, 0)"
                class="mt-3 normal-letter-spacing ml-3">
                <v-icon class="ml-1">mdi-plus mdi-18px</v-icon>
                افزودن فنس منطقه
              </v-btn>
            </v-col>
          </v-row>
          <v-row no-gutters class="background-main mx-2">
            <v-col cols="12">
              <v-card height="68vh" elevation="0" class="card-width body-card">
                <v-card-text>
                  <v-row>
                    <v-col cols="4" v-for="(item, index) in stationCoverageZonesFilteredList" :key="item.id">
                      <div class="items-back"></div>
                      <v-row no-gutters>
                        <v-col cols="1"></v-col>
                        <v-col cols="10">
                          <v-card height="11vh" class="mt-4 mr-2">
                            <v-row no-gutters>
                              <v-col cols="2">
                                <v-row class="items-space" no-gutters></v-row>
                                <v-row no-gutters>
                                  <v-col cols="12" class="items-circle">
                                    <v-row class="items-space-above" no-gutters></v-row>
                                    <v-row no-gutters>
                                      <v-col cols="8" class="items-circle-above">
                                        <v-row no-gutters>
                                          <v-col cols="12" class="text-center items-index-space">
                                            <span class="items-index">{{ index + 1 }}</span>
                                          </v-col>
                                        </v-row>
                                      </v-col>
                                      <v-spacer></v-spacer>
                                    </v-row>
                                  </v-col>
                                </v-row>
                              </v-col>
                              <v-col cols="6" class="items-card-text-space">
                                <span>{{ item.title }}</span>
                              </v-col>
                              <v-col cols="1" class="items-card-text-space">
                                <v-tooltip top>
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-icon color="darkColor" style="cursor: pointer"
                                      @click="enableAddEditFunction(2, item.id)" v-bind="attrs" v-on="on">
                                      mdi-map-marker-radius mdi-24px
                                    </v-icon>
                                  </template>
                                  <span>ویرایش</span>
                                </v-tooltip>
                              </v-col>
                              <v-col cols="1" class="items-card-text-space">
                                <v-tooltip top>
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-icon color="darkColor" style="cursor: pointer" @click="showLakeModal(item.id)"
                                      v-bind="attrs" v-on="on">
                                      mdi-car-cog mdi-24px
                                    </v-icon>
                                  </template>
                                  <span>فاقدی</span>
                                </v-tooltip>
                              </v-col>
                              <v-col cols="1" class="ml-3 items-card-text-space">
                                <v-tooltip top>
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-icon color="darkColor" style="cursor: pointer"
                                      @click="showDeleteConfirmFunction(item.id)" v-bind="attrs" v-on="on">
                                      mdi-delete mdi-24px
                                    </v-icon>
                                  </template>
                                  <span>حذف</span>
                                </v-tooltip>
                              </v-col>
                            </v-row>
                          </v-card>
                        </v-col>
                      </v-row>
                    </v-col>
                    <!-- <v-col cols="4">
                      <div class="items-back-add"></div>
                      <v-row>
                        <v-col cols="1"></v-col>
                        <v-col cols="10">
                          <v-card height="11vh" class="mt-4 mr-2 item-add-card">
                            <v-row no-gutters>
                              <v-col cols="2">
                                <v-row class="items-space" no-gutters></v-row>
                                <v-row no-gutters>
                                  <v-col cols="12" class="items-circle">
                                    <v-row class="items-space-above" no-gutters></v-row>
                                    <v-row no-gutters>
                                      <v-col cols="8" class="items-circle-above-add text-center">
                                        <v-row no-gutters>
                                          <v-col cols="12" class="text-center items-index-space">
                                            <span class="items-index">
                                              {{ allStationCoverageZones.length + 1 }}
                                            </span>
                                          </v-col>
                                        </v-row>
                                      </v-col>
                                      <v-spacer></v-spacer>
                                    </v-row>
                                  </v-col>
                                </v-row>
                              </v-col>
                              <v-col class="items-card-text-space">
                                <span>عنوان:</span>
                              </v-col>
                              <v-spacer></v-spacer>
                              <v-col cols="1" class="items-card-text-space">
                                <v-tooltip top>
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-icon color="darkColor" style="cursor: pointer"
                                      @click="enableAddEditFunction(1, 0)" v-bind="attrs" v-on="on">
                                      mdi-plus mdi-24px
                                    </v-icon>
                                  </template>
                                  <span>افزودن</span>
                                </v-tooltip>
                              </v-col>
                              <v-col cols="1"></v-col>
                            </v-row>
                          </v-card>
                        </v-col>
                      </v-row>
                    </v-col> -->
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-img>
      </v-col>
    </v-row>
    <alert-component ref="snackRef" :snakTimeOut="snakTimeOut" :snackColor="snackColor" :snackText="snackText"
      :snakIcon="snakIcon"></alert-component>
  </div>
</template>
<script>
import { latLng } from 'leaflet';
import L from 'leaflet';
import { LMap, LTileLayer, LPolygon, LControl } from 'vue2-leaflet';
import 'leaflet/dist/leaflet.css';
import '@geoman-io/leaflet-geoman-free';
import '@geoman-io/leaflet-geoman-free/dist/leaflet-geoman.css';

import confirmDialog from '../../components/ConfirmDialog.vue';
import AlertComponent from '../../components/AlertComponent.vue';
import SharedMap from '@/Mixins/map';
import snackBar from '@/Mixins/snackBar.js';
import ShearedMixin from '@/Mixins/Shared.js';
import SharedHelper from '@/Helpers/Shared.js';
import pagination from '@/Mixins/Pagination';
import stationCoverageZoneMixin from '@/Mixins/BaseInformation/StationCoverageZoneMixin';
import stationCoverageZoneHelper from '@/Helpers/BaseInformation/StationCoverageZoneHelper';
import StationMixin from '@/Mixins/BaseInformation/StationMixin.js';
import StationCoverageZoneSupportStationMixin from '@/Mixins/BaseInformation/StationCoverageZoneSupportStationMixin.js';
export default {
  name: 'StationCoverageZoneManagment',
  title: 'فنس منطقه',
  inject: ['load', 'tableImg', 'tableTitleImage'],
  components: {
    confirmDialog,
    AlertComponent,
    LMap,
    LTileLayer,
    LPolygon,
    LControl,
  },
  mixins: [
    pagination,
    ShearedMixin,
    stationCoverageZoneMixin,
    stationCoverageZoneHelper,
    snackBar,
    SharedHelper,
    StationMixin,
    StationCoverageZoneSupportStationMixin,
    SharedMap,
  ],
  created() {
    this.$root.$refs.StationCoverageZoneManagment = this;
  },
  mounted() {
    this.mounteLoding();
  },
  data() {
    return {
      withPopup: latLng(30.2839, 57.0834),
      withTooltip: latLng(30.2839, 57.0834),
      currentZoom: 12,
      currentCenter: latLng(30.2839, 57.0834),
      showParagraph: false,
      mapOptions: {
        zoomSnap: 0.5,
        scrollWheelZoom: true,
      },
      position: null,
      dragging: false,
      icon: this.getIcon,
      //fance
      fanceMapOptions: {
        zoomSnap: 0.5,
        scrollWheelZoom: true,
      },
      // fanceCenter: latLng(30.2839, 57.0834),
      fanceZoom: 12,
      center_My: latLng(30.2839, 57.0834),
    };
  },
  methods: {
    mounte: function () {
      L.Icon.Default.mergeOptions({
        iconRetinaUrl: require('@/assets/images/marker-icon-2x.png'),
        iconUrl: require('@/assets/images/marker-icon.png'),
        shadowUrl: require('@/assets/images/marker-shadow.png'),
      });
      this.stationId = this.$route.params.id;
      this.stationCoverageZone.stationId = this.stationId;
      this.getAllStationCoverageZones(this.stationId);
      this.getAllStationCoverageZonesForAllStations();
      this.setFanceMapBaseSystemSetting();
    },
    //map
    centerUpdate(center) {
      this.currentCenter = center;
    },
    zoomUpdate(zoom) {
      this.currentZoom = zoom;
    },
    mapInvalidate: function () {
      setTimeout(() => {
        this.$refs.modalmap.mapObject.invalidateSize();
      }, 100);
    },
    addMarker(event) {
      this.position = event.latlng;
    },
    //fance
    fanceCenterUpdate(center) {
      this.currentCenter = center;
    },
    fanceZoomUpdate(zoom) {
      this.currentZoom = zoom;
    },
    fanceMapInvalidate: function () {
      setTimeout(() => {
        this.$refs.fancemap.mapObject.invalidateSize();
        // this.$refs.fancemap?.mapObject?.flyTo([this.patientLat, this.patientLng], 17);
      }, 100);
    },
  },
  watch: {
    colorValue: function (val) {
      const map = this.$refs.fancemap.mapObject;
      map.pm.setLang('fa');
      map.pm.setPathOptions({
        color: val,
        fillColor: val,
        fillOpacity: 0.4,
      });
    },
    currentFenceCoords: function (currentVal) {
      this.fenceCentering(currentVal);
    },
    '$store.state.SystemSettingModule.systemSetting': {
      handler(newVal) {
        const lat = newVal?.mapCenterLatitude ?? 30.2839;
        const lng = newVal?.mapCenterLongitude ?? 57.0834;
        this.center_My = [lat, lng];

      },
      immediate: true,
      deep: true,
    },
  },
  computed: {
    stationCoverageZonesFilteredList() {
      return this.allStationCoverageZones.filter((u) => {
        return u.title.toLowerCase().includes(this.searchTitle.toLowerCase());
      });
    },
    swatchStyle() {
      const { colorValue, menu } = this;
      return {
        backgroundColor: colorValue,
        cursor: 'pointer',
        height: '30px',
        width: '30px',
        borderRadius: menu ? '50%' : '4px',
        transition: 'border-radius 200ms ease-in-out',
      };
    },
  },
};
</script>
<style scoped>
.items-back {
  background: var(--dark-color) !important;
  position: absolute;
  height: 15vh;
  width: 13%;
  border-radius: 14px !important;
}

.items-back-add {
  background: var(--one-field-color) !important;
  position: absolute;
  height: 15vh;
  width: 13%;
  border-radius: 14px !important;
}

.items-circle {
  width: 7.5vh;
  height: 7.5vh;
  border-radius: 50% !important;
  background: white;
  margin-right: -3.7vh;
}

.items-space {
  height: 1.75vh;
}

.items-circle-above {
  width: 5vh;
  height: 5vh;
  border-radius: 50% !important;
  background: var(--dark-color);
  margin-right: 1vh;
  box-shadow: 0 3px 5px -1px rgba(0, 0, 0, 0.2), 0 5px 8px 0 rgba(0, 0, 0, 0.14),
    0 1px 14px 0 rgba(0, 0, 0, 0.12) !important;
}

.items-circle-above-add {
  width: 5vh;
  height: 5vh;
  border-radius: 50% !important;
  background: var(--one-field-color);
  margin-right: 1vh;
  box-shadow: 0 3px 5px -1px rgba(0, 0, 0, 0.2), 0 5px 8px 0 rgba(0, 0, 0, 0.14),
    0 1px 14px 0 rgba(0, 0, 0, 0.12) !important;
}

.items-space-above {
  height: 1.2vh;
}

.items-index {
  color: white;
}

.items-index-space {
  margin-top: 1.3vh !important;
}

.items-card-text-space {
  margin-top: 4vh;
}

.item-add-card {
  border: 2px dashed #c0d1e2 !important;
}

.confirm-cancel-btn {
  border: solid 1px var(--dark-color);
  padding-top: 13px;
  padding-bottom: 15px;
  color: var(--dark-color);
}

.body-card {
  overflow-y: auto !important;
}

@media only screen and (min-width: 1280px) {
  .table-content {
    margin-top: 1vh !important;
  }

  .card-width {
    width: 99% !important;
    margin-right: 2vh !important;
  }
}

@media only screen and (min-width: 1366px) {
  .table-content {
    margin-top: 1vh !important;
  }

  .card-width {
    width: 98.5% !important;
    margin-right: 2vh !important;
  }
}

@media only screen and (min-width: 1536px) {
  .table-content {
    margin-top: 1vh !important;
  }

  .card-width {
    width: 99% !important;
    margin-right: 1vh !important;
  }
}
</style>
